
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 30"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"48","height":"30","fill":"#fff","rx":"2"}}),_c('path',{attrs:{"fill":"#006FCF","d":"m42.65 7.36.96-2.61H48V2c0-1.1-.9-2-2-2H2C.9 0 0 .9 0 2v26c0 1.1.9 2 2 2h44c1.1 0 2-.9 2-2v-2.74h-4.14l-1.53-1.79-1.59 1.79H28.98v-9.53H25.1l4.85-10.98h4.72l1.14 2.49V4.75h5.86l.98 2.61Zm-3.31 1.73V8.04l.39 1.05 1.95 5.21h1.94l1.96-5.21.38-1.04v6.25H48v-8h-3.39l-1.54 4.06-.41 1.1-.42-1.1-1.55-4.06H37.3v8h2.04V9.09Zm-4.39 5.21h2.35l-3.52-8h-2.73l-3.54 8h2.32l.62-1.54h3.88l.62 1.54Zm-2.96-5.29.4-1 .4 1 .83 2.02h-2.46l.83-2.02Zm-1.37 6.73v7.97h6.68v-1.73h-4.64v-1.39h4.55v-1.72h-4.55v-1.4h4.64v-1.73h-6.68Zm14.11 7.97h2.65l-3.74-4 3.74-3.97h-2.61l-2.41 2.59-2.4-2.59H37.3l3.73 4-3.73 3.97h2.58l2.43-2.6 2.42 2.6Zm1.01-4.01L48 22v-4.57l-2.26 2.27Z"}})])
          )
        }
      }
    